var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTryon = function SvgTryon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 41",
    className: "svgr-icon"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.594,
    fill: "#FCA5E3",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    y: 0.594,
    fill: "url(#tryon_svg__a)",
    fillOpacity: 0.8,
    rx: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#001E36",
    d: "M12.525 14.049 16.04 25.1h.135l3.523-11.051h3.409l-5.014 14.545H14.13L9.108 14.05zM30.603 17.685v2.273h-6.57v-2.273zm-5.078-2.613h3.026v10.17q0 .42.128.653a.7.7 0 0 0 .355.32q.234.093.54.092.213 0 .426-.035l.326-.064.476 2.251a9 9 0 0 1-.639.164 5 5 0 0 1-1.001.12q-1.095.043-1.918-.29a2.68 2.68 0 0 1-1.271-1.038q-.454-.702-.448-1.775z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tryon_svg__a",
    x1: 29.5,
    x2: 4,
    y1: 38.094,
    y2: 8.594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA00B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};
export default SvgTryon;